import { useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import useRequestsByProvider from "../../../hooks/useRequestsByProvider";
import RequestsTable from "../../../components/RequestsTable/RequestsTable";

const CompleteRequests = () => {
  const {
    user: { medical_provider_id: providerId },
  } = useContext(UserContext);

  const { requests } = useRequestsByProvider(providerId, "Complete");

  return (
    <RequestsTable
      title="Complete Requests"
      requests={requests}
      showActions={false} // No action buttons
    />
  );
};

export default CompleteRequests;
